// extracted by mini-css-extract-plugin
export default {"container":"Cuvc4","library":"TyqvN","library-closed":"CEBAO","workspace":"BGdA3","workspace-scrollable":"mKVg_","workspace-content":"gh66M"};